import { useIsTextEnlarged } from "./useIsTextEnlarged";

/** Luxon weekday formats a calendar header uses: `Sun` normally, `S` once enlarged text no longer fits. */
export type CalendarWeekdayFormat = "ccc" | "ccccc";

/** The weekday format for a calendar header: three-letter weekdays overflow a phone's day columns at enlarged text. */
export const useWeekdayLabelFormat = (): CalendarWeekdayFormat => (useIsTextEnlarged() ? "ccccc" : "ccc");
